module.exports = __webpack_public_path__ + "8e023cdfa4e3eb2da064be013382f3ca.png";